// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import '../static/fontIcon/iconfont.css'

import VueHighlightJS from 'vue-highlight.js';
import 'highlight.js/styles/atelier-dune-dark.css'
// import 'highlight.js/styles/default.css';
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueHighlightJS)

import store from './store'//vue状态管理
import routerControle from './router/routerControle'

routerControle();//路由周期逻辑函数
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./src/main.js